// @flow
import * as React from "react";
import { connect } from "react-redux";
import { withRouter, type RouterHistory } from "react-router-dom";
import { get } from "../common/fetch";
import { Button, Spinner } from "./Item";

import type { Dispatch } from "../../redux/action";

type Props = {
  onClick: () => void,
  dispatch: Dispatch,
  history: RouterHistory,
  children: React.Node
};

type State = {
  fetching: boolean
};

class ButtonSubscribe extends React.Component<Props, State> {
  state = {
    fetching: false
  };

  subscribe = async () => {
    this.setState({ fetching: true });

    const response = await get("/profile-update?daily_mail=1");
    if (response.status === "OK") {
      this.props.dispatch({
        type: "UPDATE_PROFILE",
        payload: { daily_mail: 1 }
      });
      this.setState({ fetching: false });
      this.props.onClick();
      this.props.history.push(response.redirect);
      return;
    }

    this.setState({ fetching: false });
    this.props.onClick();
  };

  render() {
    return (
      <Button
        type="trade"
        disabled={this.state.fetching}
        onClick={this.subscribe}
      >
        {this.state.fetching ? <Spinner /> : this.props.children}
      </Button>
    );
  }
}

export default withRouter(connect()(ButtonSubscribe));



// WEBPACK FOOTER //
// ./src/components/Bell/ButtonSubscribe.js